import { SELECTED_LANGUAGE_STORAGE_KEY } from "../../../helpers/constants";

export const loadLocaleData = locale => {
    switch (locale) {
        case "de":
            return import("./locales/de.json");
        default:
            return import("./locales/en.json");
    }
};

export const getLanguagePreference = () => {
    const languagePreference = localStorage.getItem(SELECTED_LANGUAGE_STORAGE_KEY);
    const defaultLanguage = languagePreference || navigator.language.split("-")[0];

    return ["en", "de"].includes(defaultLanguage) ? defaultLanguage : "de";
};
